import React from 'react'
import CountUp from 'react-countup'

import stats1 from '../../assets/img/counter/counter__1.png'
import stats2 from '../../assets/img/counter/counter__2.png'
import stats3 from '../../assets/img/counter/counter__3.png'
import stats4 from '../../assets/img/counter/counter__4.png'

function Stats() {
  return (
    <div>
 
      <div class="counterarea sp_bottom_100 sp_top_50">
            <div class="container">
                <div class="row">
                    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 aos-init aos-animate" data-aos="fade-up">
                        <div class="counterarea__text__wraper">
                            <div class="counter__img">
                                <img loading="lazy" src={stats2} alt="counter"/>
                            </div>
                            <div class="counter__content__wraper">
                                <div class="counter__number">
                                    {/* <span class="counter">2500</span>+ */}
                                    <CountUp end={2500} duration={3} /> +

                                </div>
                                <p>STUDENTS</p>

                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 aos-init aos-animate" data-aos="fade-up">
                        <div class="counterarea__text__wraper">
                            <div class="counter__img">
                                <img loading="lazy" src={stats3} alt="counter"/>
                            </div>
                            <div class="counter__content__wraper">
                                <div class="counter__number">
                                    {/* <span class="counter">7</span>+ */}
                                    <CountUp end={7} duration={3} /> +
                                </div>
                                <p>MENTORS</p>

                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 aos-init aos-animate" data-aos="fade-up">
                        <div class="counterarea__text__wraper">
                            <div class="counter__img">
                                <img loading="lazy" src={stats1} alt="counter"/>
                            </div>
                            <div class="counter__content__wraper">
                                <div class="counter__number">
                                    {/* <span class="counter">10</span>+ */}
                         <CountUp end={10} duration={3}/> +
                                </div>
                                <p>COURSES</p>

                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 aos-init aos-animate" data-aos="fade-up">
                        <div class="counterarea__text__wraper">
                            <div class="counter__img">
                                <img loading="lazy" src={stats4} alt="counter"/>
                            </div>
                            <div class="counter__content__wraper">
                                <div class="counter__number">
                                    {/* <span class="counter">100</span>+ */}
                                    <CountUp end={100} duration={3}/> +
                                </div>
                                <p>CORPORATE WORKSHOPS</p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    
    </div>
  )
}

export default Stats
